import { render, staticRenderFns } from "./RModal.vue?vue&type=template&id=18c03bde&scoped=true"
import script from "./RModal.vue?vue&type=script&lang=js"
export * from "./RModal.vue?vue&type=script&lang=js"
import style0 from "./RModal.vue?vue&type=style&index=0&id=18c03bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c03bde",
  null
  
)

export default component.exports